export enum EnumTeamMemberSlideSize {
	EXTRA_LARGE = 490,
	LARGE = 243,
	MEDIUM = 219,
	SMALL = 154,
}
